import { cn } from '@/lib/utils';
import { useTranslation } from '../../hooks/useTranslation';

const shimmerBar = 'bg-dinnerplate-white-light animate-shimmer rounded-xs';

export function JobCardSkeleton() {
  const { t } = useTranslation();
  return (
    <div
      role="status"
      aria-busy="true"
      aria-label={t('loading_job')}
      className="w-full rounded-input border border-dinnerplate-white bg-off-white p-6 shadow-soft flex flex-col gap-4"
    >
      <div className="flex flex-col items-start gap-1 w-full">
        <div className="flex items-start gap-4 w-full">
          <div className={cn(shimmerBar, 'flex-1 h-6')} />
          <div className={cn(shimmerBar, 'h-6 w-24')} />
        </div>
        <div className={cn(shimmerBar, 'h-6 w-48')} />
      </div>
      <div className="flex items-center gap-4 w-full">
        <div className={cn(shimmerBar, 'size-16')} />
        <div className="flex flex-1 items-center gap-4">
          <div className={cn(shimmerBar, 'flex-1 h-6')} />
          <div className={cn(shimmerBar, 'h-6 w-24')} />
        </div>
      </div>
    </div>
  );
}
